import { useState, useCallback } from 'react';

/**
 * Custom hook for managing temporary input values
 * @returns {Object} - Object with temp values state and handlers
 */
export function useTempValues() {
  const [tempValues, setTempValues] = useState({});

  const updateTempValue = useCallback((key, value) => {
    setTempValues(prev => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const clearTempValue = useCallback((key) => {
    setTempValues(prev => {
      const newTempValues = { ...prev };
      delete newTempValues[key];
      return newTempValues;
    });
  }, []);

  const getTempValue = useCallback((key) => {
    return tempValues[key];
  }, [tempValues]);

  return {
    tempValues,
    updateTempValue,
    clearTempValue,
    getTempValue
  };
}
